<div class="css-Campo_Default campo_default">
  <p class="css-Etiqueta etiqueta">{{ descripcion_etiqueta }}</p>
  <div class="css-Campo_mensaje campo_mensaje">
    <input [type]="type" class="css-input_text_Campo input_text_campo" name="input_text_campo"
      placeholder="{{ placeholder_input }}" [(ngModel)]="modelValue" (keydown.enter)="onEnterPressed()"
      (ngModelChange)="onInputChange($event)" (blur)="onBlur()" />
    <div class="css-mensaje_error mensaje_error error-off" *ngIf="mensaje_error.length > 0">
      <div class="css-Icono_Error_Forms-1 icono_error_forms">
        <img src="assets/images/basecomponents-images/campo-default.svg" width="9px" height="9px"
          class="css-close close" />
      </div>
      <p class="css-Texto-1 texto">{{ mensaje_error }}</p>
    </div>
  </div>
</div>